export const defaults = {
    promotionalSignUpReducer: {},
};

export const selectPromotionalSignUpContent = (state) =>
    state?.promotionalSignUpReducer || defaults.promotionalSignUpReducer;
